import React from "react";
//import { UilPostcard, UilSchedule, UilGoogle, UilTable, UilComparison, UilChartBar, UilRecordAudio, UilChartLine, UilChartPieAlt  } from '@iconscout/react-unicons';
import { CardNumericWidget } from "./cardnumericwidget";
import { CardDateWidget } from "./carddatewidget";
import { CardGaugeWidget } from "./cardgaugewidget"
import { GridWidget } from "./gridwidget";
import { GenericChartWidget } from './genericchartwidget';
import { TickerWidget } from './tickerwidget';
import { showSettingsForm as showSettingsFormDesign, removeWidget, chartToGrid, gridToChart, redirectToSchedule } from "../../redux/slices/reportingdesignpageslice";
import { showFilterForm, showSettingsForm as showSettingsFormView, widgetGenerateReport, cancelWidget, gridExportToExcel, redirectToSchedulePage } from "../../redux/slices/reportingviewpageslice";
import { SvgIcon } from "@progress/kendo-react-common";
import {
    parameterIntegerIcon as NumericCardIcon, calendarIcon as DateCardIcon, slidersIcon as GaugeIcon, tableIcon as TableIcon,
    chartAreaStackedIcon as AreaChartIcon, 
    chartColumnClusteredIcon as VBarChartIcon, chartColumnStackedIcon as VBarStackedChartIcon, 
    chartBarStackedIcon as HBarStackedChartIcon, chartBarClusteredIcon as HBarChartIcon, chartDoughnutIcon as DoughnutIcon,
    chartLineStackedIcon as LineChartIcon, chartColumnRangeIcon as RangeBarIcon, chartAreaRangeIcon as RangeAreaIcon, chartPieIcon as PieChartIcon, filmIcon as TickerIcon
} from "@progress/kendo-svg-icons";
import { isInteger, isNumeric, dateTimeToString, compareUnary } from "../../components/../lib/utils";
import { ReactComponent as GaugeNiceIcon } from  "../../icons/gauge.svg";
import { ReactComponent as FunnelNiceIcon } from  "../../icons/funnel.svg";
import { ReactComponent as WaterfallNiceIcon } from  "../../icons/waterfall.svg";
import i18next from "i18next";

export const WIDGET_NUMERIC_CARD = 1;
export const WIDGET_DATE_CARD = 2;
export const WIDGET_GAUGE_CARD = 10;

export const WIDGET_GRID = 20;

export const WIDGET_LINE_CHART = 30;
export const WIDGET_AREA_CHART = 31;
export const WIDGET_HBAR_CHART = 32;
export const WIDGET_HBARSTACKED_CHART = 33;
export const WIDGET_VBAR_CHART = 34;
export const WIDGET_VBARSTACKED_CHART = 35;
export const WIDGET_PIE_CHART = 36;
export const WIDGET_DOUGHNUT_CHART = 37;
export const WIDGET_FUNNEL_CHART = 38;
export const WIDGET_WATERFALL_CHART = 39;
export const WIDGET_RANGEBAR_CHART = 40;
export const WIDGET_RANGEAREA_CHART = 41;

export const WIDGET_TICKER = 60;
export const WIDGET_MAP = 65;

export const defaultGridFieldSettings = {
    isLocked: false,  isVisible: true, isSorted: false, sortDirection: "", isGrouped: false, aggregate: null, groupOrder: 0,
    backgroundColor: 1, fontSize: 14, fontIsBold: false, fontIsItalic: false, fontIsUnderline: false, fontColor: 9,
    ruleOperator: 0, ruleValue: "", ruleBackgroundColor: 1, ruleFontColor: 9, ruleFontSize: 16, ruleFontIsBold: true, 
    ruleFontIsItalic: true, ruleFontIsUnderline: false
};

export const isErrorColor = (value, operatorId, threshold ) => {
    if (value === null || value === undefined || threshold === null || threshold === undefined)
       return null;
    
    if (!isNumeric(value.toString()) || !isNumeric(operatorId.toString()) || operatorId < 1 || operatorId > 6 || !isNumeric(threshold.toString()))
    return null;//no answer

    return compareUnary(value.toString(), operatorId, threshold.toString());
};

export const getVariationDirection = (value, isVariationReverse, threshold = 0) => {
    if (!isNumeric(value) || !isNumeric(threshold))
        return null;

    if (isVariationReverse)
        return value >= threshold ? -1 : 1;
    else
        return value < threshold ? -1 : 1;
};

export const DEFAULT_ROW_HEIGHT = 10;

export const widgetsInfo =  [
    {
        id: WIDGET_NUMERIC_CARD, key: "numericCard", title: "Numeric Card", type: WIDGET_NUMERIC_CARD, subType: 0, dataSourceType: 1, dataSourceValueType: 2, icon: NumericCardIcon, defaultPosition: {colSpan:6, rowSpan:12},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "", titleFontSize: 18, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fontSize: 56, fontIsBold: true, fontIsItalic: false, fontIsUnderline: false, fontColor: 5, 
            decimalPlaces:2, thousandSeparator: 1, trailingValue: "",
            isVariation: false, isVariationReverse: false, trimLargeValue: true,
            errorOperator: 0, errorThreshold: "", beep: false
        },
        unInitIconSize: {fontSize: 120}
    },

    {
        id: WIDGET_DATE_CARD, key: "dateCard", title: "Date Card", type: WIDGET_DATE_CARD, subType: 0, dataSourceType: 1, dataSourceValueType: 4, icon: DateCardIcon, defaultPosition: {colSpan:6, rowSpan:12},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "", 
            titleFontSize: 18, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fontSize: 40, fontIsBold: true, fontIsItalic: false, fontIsUnderline: false, fontColor: 5,
            dateFormat: 3,
        },
        unInitIconSize: {fontSize: 120}
    },
    
    {
        id: WIDGET_GAUGE_CARD, key: "gaugeCard", title: "Gauge Card", type: WIDGET_GAUGE_CARD, subType: 0, dataSourceType: 1, dataSourceValueType: 2, icon: GaugeNiceIcon, defaultPosition: {colSpan:6, rowSpan:12},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "", 
            titleFontSize: 18, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fontSize: 40, fontIsBold: true, fontIsItalic: false, fontIsUnderline: false, fontColor: 5,
            shape:1, min: "", max: "", decimalPlaces: 2, trimLargeValue: true, showTicks: false,
            errorOperator: 0, errorThreshold: "", beep: false
        },
        unInitIconSize: {fontSize: 120}
    },

    {
        id: WIDGET_GRID, key: "grid", title: "Grid", type: WIDGET_GRID, subType: 0, dataSourceType: 2, dataSourceValueType: 0, icon: TableIcon, defaultPosition: {colSpan:24, rowSpan:16},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "",
            titleFontSize: 16, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            pageSize: 50, fields: [], groupable: false, filterable: false, maximumRows: 5000, maximumRowsMock: 5000
        },
        unInitIconSize: {fontSize: 120}
    },

    {
        id: WIDGET_LINE_CHART, key: "lineChart", title: "Line Chart", type: WIDGET_LINE_CHART, subType: 0, dataSourceType: 2, dataSourceValueType: 0, icon: LineChartIcon, defaultPosition: {colSpan:12, rowSpan:16},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "",
            titleFontSize: 14, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fields: [], categoryFieldId: 0, valueFieldId: 0, secondaryFieldId: 0, sortFieldId: 0, sortFieldDirectionId: -1, aggregate: null, legendPosition: 8, lineStyle:1,
            topDirectionId: 0, topCount: 0, maximumRows: 5000, maximumRowsMock: 5000
        },
        unInitIconSize: {fontSize: 120}
    },
    {
        id: WIDGET_AREA_CHART, key: "areaChart", title: "Area Chart", type: WIDGET_AREA_CHART, subType: 0, dataSourceType: 2, dataSourceValueType: 0, icon: AreaChartIcon, defaultPosition: {colSpan:12, rowSpan:16},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "",
            titleFontSize: 14, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fields: [], categoryFieldId: 0, valueFieldId: 0, secondaryFieldId: 0, sortFieldId: 0, sortFieldDirectionId: -1, aggregate: null, legendPosition: 8, lineStyle:1, 
            topDirectionId: 0, topCount: 0, maximumRows: 5000, maximumRowsMock: 5000
        },
        unInitIconSize: {fontSize: 120}
    },
    {
        id: WIDGET_HBAR_CHART, key: "hbarChart", title: "H. Bar Chart", type: WIDGET_HBAR_CHART, subType: 0, dataSourceType: 2, dataSourceValueType: 0, icon: HBarChartIcon, defaultPosition: {colSpan:12, rowSpan:16},
        defaultSettings: {
            reorderable: true, resizable: true,             
            title: "",
            titleFontSize: 14, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fields: [], categoryFieldId: 0, valueFieldId: 0, secondaryFieldId: 0, sortFieldId: 0, sortFieldDirectionId: -1, aggregate: null, legendPosition: 8, lineStyle:1, 
            topDirectionId: 0, topCount: 0, maximumRows: 5000, maximumRowsMock: 5000
        },
        unInitIconSize: {fontSize: 120}
    },
    {
        id: WIDGET_HBARSTACKED_CHART, key: "hbarstackedChart", title: "H. Bar Stacked Chart", type: WIDGET_HBARSTACKED_CHART, subType: 0, dataSourceType: 2, dataSourceValueType: 0, icon: HBarStackedChartIcon, defaultPosition: {colSpan:12, rowSpan:16},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "",
            titleFontSize: 14, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fields: [], categoryFieldId: 0, valueFieldId: 0, secondaryFieldId: 0, sortFieldId: 0, sortFieldDirectionId: -1, aggregate: null, legendPosition: 8, lineStyle:1, 
            topDirectionId: 0, topCount: 0, maximumRows: 5000, maximumRowsMock: 5000
        },
        unInitIconSize: {fontSize: 120}
        
    },
    {
        id: WIDGET_VBAR_CHART, key: "vbarChart", title: "V. Bar Chart", type: WIDGET_VBAR_CHART, subType: 0, dataSourceType: 2, dataSourceValueType: 0, icon: VBarChartIcon, defaultPosition: {colSpan:12, rowSpan:16},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "",
            titleFontSize: 14, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fields: [], categoryFieldId: 0, valueFieldId: 0, secondaryFieldId: 0, sortFieldId: 0, sortFieldDirectionId: -1, aggregate: null, legendPosition: 8, lineStyle:1,  
            topDirectionId: 0, topCount: 0, maximumRows: 5000, maximumRowsMock: 5000
        },
        unInitIconSize: {fontSize: 120}
    },
    {
        id: WIDGET_VBARSTACKED_CHART, key: "vbarstackedChart", title: "V. Bar Stacked Chart", type: WIDGET_VBARSTACKED_CHART, subType: 0, dataSourceType: 2, dataSourceValueType: 0, icon: VBarStackedChartIcon, defaultPosition: {colSpan:12, rowSpan:16},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "",
            titleFontSize: 14, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fields: [], categoryFieldId: 0, valueFieldId: 0, secondaryFieldId: 0, sortFieldId: 0, sortFieldDirectionId: -1, aggregate: null, legendPosition: 8, lineStyle:1,
            topDirectionId: 0, topCount: 0, maximumRows: 5000, maximumRowsMock: 5000
        },
        unInitIconSize: {fontSize: 120}
    },
    {
        id: WIDGET_FUNNEL_CHART, key: "funnelChart", title: "Funnel Chart", type: WIDGET_FUNNEL_CHART, subType: 0, dataSourceType: 2, dataSourceValueType: 0, icon: FunnelNiceIcon, defaultPosition: {colSpan:8, rowSpan:16},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "",
            titleFontSize: 14, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fields: [], categoryFieldId: 0, valueFieldId: 0, secondaryFieldId: 0, sortFieldId: 0, sortFieldDirectionId: -1, aggregate: null, legendPosition: 8, lineStyle:1, 
            topDirectionId: 0, topCount: 0, maximumRows: 5000, maximumRowsMock: 5000
        },
        unInitIconSize: {fontSize: 120}
    },
    {
        id: WIDGET_WATERFALL_CHART, key: "waterfallChart", title: "Waterfall Chart", type: WIDGET_WATERFALL_CHART, subType: 0, dataSourceType: 2, dataSourceValueType: 0, icon: WaterfallNiceIcon, defaultPosition: {colSpan:12, rowSpan:16},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "",
            titleFontSize: 14, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fields: [], categoryFieldId: 0, valueFieldId: 0, secondaryFieldId: 0, sortFieldId: 0, sortFieldDirectionId: -1, aggregate: null, legendPosition: 8, lineStyle:1, 
            topDirectionId: 0, topCount: 0, maximumRows: 5000, maximumRowsMock: 5000
        },
        unInitIconSize: {fontSize: 120}
    },
    {
        id: WIDGET_RANGEBAR_CHART, key: "rangeBarChart", title: "Range Bar Chart", type: WIDGET_RANGEBAR_CHART, subType: 0, dataSourceType: 2, dataSourceValueType: 0, icon: RangeBarIcon, defaultPosition: {colSpan:12, rowSpan:16},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "",
            titleFontSize: 14, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fields: [], categoryFieldId: 0, valueFieldId: 0, secondaryFieldId: 0, sortFieldId: 0, sortFieldDirectionId: -1, aggregate: null, legendPosition: 8, lineStyle:1, 
            topDirectionId: 0, topCount: 0, maximumRows: 5000, maximumRowsMock: 5000
        },
        unInitIconSize: {fontSize: 120}
    },
    {
        id: WIDGET_RANGEAREA_CHART, key: "rangeAreaChart", title: "Range Area Chart", type: WIDGET_RANGEAREA_CHART, subType: 0, dataSourceType: 2, dataSourceValueType: 0, icon: RangeAreaIcon, defaultPosition: {colSpan:12, rowSpan:16},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "",
            titleFontSize: 14, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fields: [], categoryFieldId: 0, valueFieldId: 0, secondaryFieldId: 0, sortFieldId: 0, sortFieldDirectionId: -1, aggregate: null, legendPosition: 8, lineStyle:1, 
            topDirectionId: 0, topCount: 0, maximumRows: 5000, maximumRowsMock: 5000
        },
        unInitIconSize: {fontSize: 120}
    },
    {
        id: WIDGET_PIE_CHART, key: "pieChart", title: "Pie Chart", type: WIDGET_PIE_CHART, subType: 0, dataSourceType: 2, dataSourceValueType: 0, icon: PieChartIcon, defaultPosition: {colSpan:8, rowSpan:16},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "",
            titleFontSize: 14, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fields: [], categoryFieldId: 0, valueFieldId: 0, secondaryFieldId: 0, sortFieldId: 0, sortFieldDirectionId: -1, aggregate: null, legendPosition: 8, lineStyle:1, maximumRows: 5000, maximumRowsMock: 5000
        },
        unInitIconSize: {fontSize: 120}    
    },
    {
        id: WIDGET_DOUGHNUT_CHART, key: "donutChart", title: "Donut Chart", type: WIDGET_DOUGHNUT_CHART, subType: 0, dataSourceType: 2, dataSourceValueType: 0, icon: DoughnutIcon, defaultPosition: {colSpan:8, rowSpan:16},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "",
            titleFontSize: 14, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fields: [], categoryFieldId: 0, valueFieldId: 0, secondaryFieldId: 0, sortFieldId: 0, sortDirectionId: -1, aggregate: null, legendPosition: 8, lineStyle:1, maximumRows: 5000, maximumRowsMock: 5000
        },
        unInitIconSize: {fontSize: 120}    
    },

    {
        id: WIDGET_TICKER, key: "ticker", title: "Ticker", type: WIDGET_TICKER, subType: 0, dataSourceType: 2, dataSourceValueType: 0, icon: TickerIcon, defaultPosition: {colSpan:24, rowSpan:3},
        defaultSettings: {
            reorderable: true, resizable: true, 
            title: "", 
            titleFontSize: 14, titleFontIsBold: true, titleFontIsItalic: false, titleFontIsUnderline: false, titleFontColor: 5,
            fontSize: 20, fontIsBold: true, fontIsItalic: false, fontIsUnderline: false, fontColor: 5, backgroundColor: 1, fields:[], maximumRows: 5000, maximumRowsMock: 100   
        },
        unInitIconSize: {fontSize: 42}
    },
];

export const fontSizes = [
        {id: 10, title: "10px"}, {id: 12, title: "12px"},{id: 13, title: "13px"},{id: 14, title: "14px"},{id: 16, title: "16px"},
        {id: 18, title: "18px"}, {id: 20, title: "20px"}, {id: 24, title: "24px"},{id: 26, title: "26px"},{id: 28, title: "28px"},{id: 30, title: "30px"},
        {id: 32, title: "32px"}, {id: 34, title: "34px"},{id: 36, title: "36px"},{id: 40, title: "40px"},{id: 42, title: "42px"},
        {id: 46, title: "46px"}, {id: 48, title: "48px"},{id: 50, title: "50px"},{id: 54, title: "54px"},{id: 56, title: "56px"},
        {id: 60, title: "60px"}, {id: 70, title: "70px"},{id: 80, title: "80px"},{id: 84, title: "84px"},{id: 90, title: "90px"}
];

export const getWidgetFontColors = (currentTheme) => {
    return ([

        {id: 1, title: "Background", color: currentTheme.componentBg},
        {id: 2, title: "Border", color: currentTheme.componentBorderColor},
        {id: 3, title: "Error", color: currentTheme.error},
        {id: 4, title: "Info", color: currentTheme.info},
        {id: 5, title: "Primary", color: currentTheme.primary},
        {id: 6, title: "Secondary", color: currentTheme.secondary},
        {id: 7, title: "Separator", color: currentTheme.separatorColor},
        {id: 8, title: "Success", color: currentTheme.success},
        {id: 9, title: "Text", color: currentTheme.componentText},
        {id: 10, title: "Warning", color: currentTheme.warning},

        {id: 11, title: "Black", color: currentTheme.black},
        {id: 12, title: "Blue", color: currentTheme.blue},
        {id: 13, title: "Green", color: currentTheme.green},
        {id: 14, title: "Orange", color: currentTheme.orange},
        {id: 15, title: "Pink", color: currentTheme.pink},
        {id: 16, title: "Purple", color: currentTheme.purple},
        {id: 17, title: "Red", color: currentTheme.red},
        {id: 18, title: "Yellow", color: currentTheme.yellow},
        {id: 19, title: "White", color: currentTheme.white}
    ]);
};

export const decimalPlaces = [{id: 0, title: "0"}, {id:1, title: "1"}, {id:2, title: "2"}, {id:3, title: "3"}, {id:4, title: "4"}, {id:5, title: "5"},  {id:6, title: "6"}, {id:7, title: "7"}, {id:8, title: "8"}];

export const thousandSeparators = [{id: 0, title: ""}, {id: 1, title: ","}];

export const gaugeShapes = [{id: 1, title: "Arc"}, {id:2, title: "Circle"}];

export const getWidgetKeyFromType = (widgetTypeId) => {
    return widgetsInfo.find (e => e.id == widgetTypeId).key;
};

export const getWidgetDefaultPosition = (key) => {
    return widgetsInfo.find(e => e.key == key).defaultPosition;
};

export const getWidgetSettingsComponent = (widgetTypeId, properties) => {
    //returns an instance of a component to the tile using the widget type id and the props
    if(widgetTypeId == WIDGET_NUMERIC_CARD)
       return <CardNumericWidget key={properties.id} {...properties} />
    else if(widgetTypeId == WIDGET_DATE_CARD)
        return <CardDateWidget key={properties.id} {...properties} />
    else if(widgetTypeId == WIDGET_GAUGE_CARD)
        return <CardGaugeWidget key={properties.id} {...properties} />
    else if(widgetTypeId == WIDGET_GRID)
        return <GridWidget key={properties.id} {...properties} />    
    else if (isChart(widgetTypeId))
        return <GenericChartWidget key={properties.id} {...properties}/>
    else if (widgetTypeId == WIDGET_TICKER)
        return <TickerWidget key={properties.id} {...properties}/>
};


export const getWidgetDesignContextMenu = (widgetTypeId) => {
  if (isChart(widgetTypeId) || widgetTypeId === WIDGET_TICKER)
    return [
      { id: 1, title: i18next.t("extras.settings"), icon: "gear" },
      { id: 7, title: i18next.t("extras.schedule"), icon: "clock" },
      { id: 2, title: "" },
      { id: 4, title: i18next.t("extras.viewData"), icon: "plus" },
      { id: 5, title: "" },
      { id: 3, title: i18next.t("extras.removeWidget"), icon: "delete" },
    ];

  if (widgetTypeId === WIDGET_GRID)
    return [
      { id: 1, title: i18next.t("extras.settings"), icon: "gear" },
      { id: 7, title: i18next.t("extras.schedule"), icon: "clock" },
      { id: 2, title: "" },
      {
        id: 6,
        title: i18next.t("extras.visualizeData"),
        icon: "image",
        items: [
          { id: 61, title: i18next.t("extras.barChart"), icon: "" },
          { id: 62, title: i18next.t("extras.donutChart"), icon: "" },
          { id: 63, title: i18next.t("extras.lineChart"), icon: "" },
          { id: 64, title: i18next.t("extras.pieChart"), icon: "" },
        ],
      },
      { id: 5, title: "" },
      { id: 3, title: i18next.t("extras.removeWidget"), icon: "delete" },
    ];

  return [
    { id: 1, title: i18next.t("extras.settings"), icon: "gear" },
    { id: 7, title: i18next.t("extras.schedule"), icon: "clock" },
    { id: 2, title: "" },
    { id: 3, title: i18next.t("extras.removeWidget"), icon: "delete" },
  ];
};


export const getWidgetViewContextMenu = (
  widgetTypeId,
  loaded,
  loading,
  canceled,
  errorText
) => {
  if (loading) {
    return [
      { id: 3, title: i18next.t("extras.cancel"), icon: "cancel" },
    ];
  } else if (loaded) {
    if (widgetTypeId === WIDGET_GRID)
      return [
        { id: 1, title: i18next.t("extras.filter"), icon: "filter" },
        { id: 2, title: "" },
        { id: 11, title: i18next.t("extras.schedule"), icon: "clock"  },
        { id: 12, title: "" },
        { id: 6, title: i18next.t("extras.generate"), icon: "reset" },
        { id: 7, title: "" },
        { id: 8, title: i18next.t("extras.exportToExcel"), icon: "excel" },
        { id: 4, title: "" },
        { id: 5, title: i18next.t("extras.settings"), icon: "gear" },
      ];
    else if (isChart(widgetTypeId))
      return [
        { id: 1, title: i18next.t("extras.filter"), icon: "filter" },
        { id: 2, title: "" },
        { id: 11, title: i18next.t("extras.schedule"), icon: "clock"  },
        { id: 12, title: "" },
        { id: 6, title: i18next.t("extras.generate"), icon: "reset" },
        { id: 4, title: "" },
        { id: 5, title: i18next.t("extras.settings"), icon: "gear" },
        { id: 10, title: "" },
      ];
    else
      return [
        { id: 1, title: i18next.t("extras.filter"), icon: "filter" },
        { id: 2, title: "" },
        { id: 11, title: i18next.t("extras.schedule"), icon: "clock"  },
        { id: 12, title: "" },
        { id: 6, title: i18next.t("extras.generate"), icon: "reset" },
        { id: 4, title: "" },
        { id: 5, title: i18next.t("extras.settings"), icon: "gear" },
      ];
  } else if (canceled || errorText) {
    return [
      { id: 1, title: i18next.t("extras.filter"), icon: "filter" },
      { id: 2, title: "" },
      { id: 11, title: i18next.t("extras.schedule"), icon: "clock"  },
      { id: 12, title: "" },
      { id: 6, title: i18next.t("extras.generate"), icon: "reset" },
      { id: 4, title: "" },
      { id: 5, title: i18next.t("extras.settings"), icon: "gear" },
    ];
  } else {
    return [
      { id: 1, title: i18next.t("extras.filter"), icon: "filter" },
      { id: 2, title: "" },
      { id: 11, title: i18next.t("extras.schedule"), icon: "clock"  },
      { id: 12, title: "" },
      { id: 6, title: i18next.t("extras.generate"), icon: "reset" },
      { id: 4, title: "" },
      { id: 5, title: i18next.t("extras.settings"), icon: "gear" },
    ];
  }
};

export const handleOnWidgetDesignContextMenuClick = (obj) => {
    //obj.id, title and icon are those of the menu item; also obj.props=widget properties and obj.dispatch is the dispatch function
    if (obj.id == 1)//show settings form
        return obj.dispatch(showSettingsFormDesign(obj.props.id));
    else if (obj.id == 7)//redirect to schedule
        return obj.dispatch(redirectToSchedule(obj.props.id));
    else if (obj.id == 3)//remove widget
        return obj.dispatch(removeWidget(obj.props.id));
    else if (obj.id == 4)//Chart -> Grid
        return obj.dispatch(chartToGrid(obj.props.id));
    else if (obj.id == 61)//Grid -> Chart
        return obj.dispatch(gridToChart({id: obj.props.id, widgetTypeId: WIDGET_VBAR_CHART}));
    else if (obj.id == 62)//Grid -> Chart
        return obj.dispatch(gridToChart({id: obj.props.id, widgetTypeId: WIDGET_DOUGHNUT_CHART}));
    else if (obj.id == 63)//Grid -> Chart
        return obj.dispatch(gridToChart({id: obj.props.id, widgetTypeId: WIDGET_LINE_CHART}));
    else if (obj.id == 64)//Grid -> Chart
        return obj.dispatch(gridToChart({id: obj.props.id, widgetTypeId: WIDGET_PIE_CHART}));
};

export const handleOnWidgetViewContextMenuClick = (obj, t) => {
    //obj.id, title and icon are those of the menu item; also obj.props=widget properties and obj.dispatch is the dispatch function
    if (obj.id == 1)//show filter form
         return obj.dispatch(showFilterForm(obj.props.id));
    else if (obj.id == 11)//redirect to schedule
        return obj.dispatch(redirectToSchedulePage(obj.props.id));
    else if (obj.id == 5)//show settings form
        return obj.dispatch(showSettingsFormView(obj.props.id));
    else if (obj.id == 3)//cancel
         return obj.dispatch(cancelWidget(obj.props.id));
    else if (obj.id == 6)//generate
    {
         let widgetId = obj.props.id;
         const newRequestId = Math.ceil((Math.random()*100000000 + 1)).toString() + (Date.now().toString()) + widgetId.toString();//(new Date()).toString();
         
         return obj.dispatch(widgetGenerateReport(widgetId, newRequestId, t));
    }
    else if (obj.id == 8)//export to excel
    {
        return obj.dispatch(gridExportToExcel(obj.props.id));    
    }
};

export const hAlignItems = [{id:1, title: "Left"}, {id:2, title: "Center"}, {id: 3, title: "Right"}];

export const getWidgetAggregateFunctions = (dataType) => {
    let arr = [
        {id: null, title: "None"},
        {id: "count", title: "Count"}
    ];

    if (dataType == 2 || dataType == 4 || dataType == 5)
    {
        arr.push( {id: "min", title: "Min"});
        arr.push( {id: "max", title: "Max"});
    }

    if (dataType == 2)
    {
        arr.push( {id: "sum", title: "Sum"});
        arr.push( {id: "average", title: "Average"});
    }

    return arr;
};

export const widgetAllAggregateFunctions = [
    {id: null, title: "None"},
    {id: "average", title: "Avg"},
    {id: "count", title: "Count"},
    {id: "min", title: "Min"},
    {id: "max", title: "Max"},
    {id: "sum", title: "Sum"}
];

export const widgetPageSizes = [
    {id: 10, title: "10"}, {id: 20, title: "20"}, {id: 30, title: "30"}, 
    {id: 50, title: "50"}, {id: 75, title: "75"}, {id: 100, title: "100"}, 
    {id: 200, title: "200"}, {id: 300, title: "300"}, {id: 400, title: "400"}, 
    {id: 500, title: "500"}, {id: 1000, title: "1000"}, {id: 2000, title: "2000"},
    {id: 3000, title: "3000"}, {id: 4000, title: "4000"},{id: 5000, title: "5000"},
    {id: 10000, title: "10000"}, {id: 15000, title: "15000"},{id: 20000, title: "20000"},
];

export const chartLegendPositions = [
    {id: 1, title: "Top Horizontal"}, {id: 2, title: "Bottom Horizontal"}, {id: 3, title: "Left Horizontal"}, {id: 4, title: "Right Horizontal"}, 
    {id: 5, title: "Top Vertical"}, {id: 6, title: "Bottom Vertical"}, {id: 7, title: "Left Vertical"}, {id: 8, title: "Right Vertical"}, 
];

export const lineChartStyles = [
    {id: 1, title: "Normal"}, {id:2, title: "Step"}, {id: 3, title: "Smooth"}
];

export const isChart = (widgetTypeId) => (
    widgetTypeId == WIDGET_LINE_CHART || widgetTypeId == WIDGET_AREA_CHART || widgetTypeId == WIDGET_HBAR_CHART || 
    widgetTypeId == WIDGET_HBARSTACKED_CHART || widgetTypeId == WIDGET_VBAR_CHART || widgetTypeId == WIDGET_VBARSTACKED_CHART || 
    widgetTypeId == WIDGET_PIE_CHART || widgetTypeId == WIDGET_DOUGHNUT_CHART || widgetTypeId == WIDGET_FUNNEL_CHART ||
    widgetTypeId == WIDGET_WATERFALL_CHART || widgetTypeId == WIDGET_RANGEBAR_CHART || widgetTypeId == WIDGET_RANGEAREA_CHART
);

export const isMinMaxChart = widgetTypeId => ( widgetTypeId == WIDGET_RANGEBAR_CHART || widgetTypeId == WIDGET_RANGEAREA_CHART);

export const sortDirections = [{id: -1, title: "Asc"}, {id: 1, title: "Desc"}];

export const zooms = [
    {id:0.25, title: "25%" }, 
    {id:0.5, title: "50%" },
    {id:0.75, title: "75%" },
    {id:1, title: "100%" },
    {id:1.25, title: "125%" },
    {id:1.5, title: "150%" },
    {id:2, title: "200%" },
];

export const parameterHasValue = (dataTypeId, isLookup, allowMultiple, value) => {
    //if the param has no value, NULL is returned; if it has a value, the transformed value is returned which
    //might be false, for example, if unchecked check box
    //for multi-select lookup, the transformed result is a string of int separated with, with no spaces between:1,7,8
    let temp = "";

    if (dataTypeId == 1)//bool
    {
        if (value != true && value != false)
            return null;
        else    
            return value;
    }
    else if (dataTypeId == 2)//numeric
    {
        if (isLookup)
        {
            if (allowMultiple)
            {
                if (!value || !Array.isArray(value) || value.length < 1)
                    return null;

                for (let i in value)
                   temp += value[i].Id + ",";

                return temp.substring(0,temp.length-1);
            }
            else
            {
                if (value == null || value === "" || !isInteger(value.toString()) || parseInt(value) <= 0)
                    return null;
                else
                    return value;
            }
        }
        else
        {          
            //number not lookup
            if (value == null || value === "" || !isNumeric(value.toString()))
                return null;                            
            else
                return value; 
        }
    }
    else if (dataTypeId == 3)//string
    {
        if (!value || value.trim() == "")
            return null;
        else
            return value;
    }
    else if (dataTypeId == 4 || dataTypeId == 5)//date
    {
        if (!value || !Date.parse(value))
            return null;
        else
            return dateTimeToString(new Date(value));
    }
};

export const validateParameters = (parameters) => {
    let result = parameters.map(e => ({...e}));
    let status = true;

    for(let p in result)
    {
        let parameter = result[p];

        let res = parameterHasValue(parameter.DataTypeId, parameter.IsLookup, parameter.AllowMultiple, parameter.Value);
        if (parameter.IsRequired && res === null)
           status = false;
        
        if (res === null)
        {
            parameter.HasValue = false;
            parameter.TransformedValue = null;
        }
        else
        {
            parameter.TransformedValue = res;
            parameter.HasValue = true;
        }
    }

    return {status: status, parameters: result};
};

export const combineParameters = (global, local) => {
    //global and local must both be arrays
    if (!global || !local || !Array.isArray(global) || !Array.isArray(local))
        return null;

    if (global.length == 0)
        return local;
    else if (local.length == 0)
        return global;

    //both are arrays and each contains 1+ element
    let result = [];

    for (let prop in global)
    {
        let g = global[prop];
        let l = local.find(e => e.Name == g.Name);

        if (parameterHasValue(l.DataTypeId, l.IsLookup, l.AllowMultiple, l.Value) !== null)
            result.push({...l});
        else if (parameterHasValue(g.DataTypeId, g.IsLookup, g.AllowMultiple, g.Value) !== null)
            result.push({...g})
        else
            result.push({...l});        
    }

    return result;
};

export  const getTilesForGenerateGlobalReport = (pageState, newRequestId) => {
    let globalWhereStatement = "";
    let globalWhereParameters = [];
    let globalParameters = [];
    let tiles = [];

    if (pageState.globalFilter.isVisible)
    {
        globalWhereStatement = pageState.globalFilter.whereStatement;
        globalWhereParameters = (pageState.globalFilter.whereParameters == "" || !pageState.globalFilter.whereParameters || !Array.isArray(pageState.globalFilter.whereParameters)) ? [] : [...pageState.globalFilter.whereParameters];
        globalParameters = (pageState.globalFilter.parameters == "" || !pageState.globalFilter.parameters || !Array.isArray(pageState.globalFilter.parameters)) ? [] : [...pageState.globalFilter.parameters];
    }

    for (let i in pageState.tiles)
    {
        let tile = pageState.tiles[i];
        let whereStatement = tile.whereStatement;
        let whereParameters = (tile.whereParameters == "" || !tile.whereParameters || !Array.isArray(tile.whereParameters)) ? [] : [...tile.whereParameters];
        let parameters = (tile.parameters == "" || !tile.parameters || !Array.isArray(tile.parameters)) ? [] : [...tile.parameters];
        let combinedParameters = [];
        let dataSourceId = tile.DataSourceId;
        let proceed = true;

        if (tile.DatasetIsParametrized)
        {
            //validate the parameters and if they are not valid put the tile in an error state and move to the next tile
            //tile has parameters; globalParameters will be/not be empty based on whether there is global filter or not which is already handled
            combinedParameters = tile.combineParameters ? combineParameters(globalParameters, parameters) : parameters;

            let res = validateParameters(combinedParameters);
            if (res.status == false)
            {
                //at least one param is required and does not exist
                tiles.push({
                    requestId: null, widgetId: tile.Id, widgetTypeId: tile.WidgetTypeId, dataSourceId: dataSourceId, 
                    loaded: false, loading: false, errorText: "Required parameters are missed", canceled: false,
                    dataSourceTypeId: tile.DataSourceTypeId, properties: tile.properties
                });
                proceed = false;
            }
            else     
            {
                combinedParameters = res.parameters.map(e => ({Key: e.Name, Value: e.TransformedValue}));                
            }
        }
        
        if (proceed)
        {
            //either no parameters or NO problem in the current tile's parameters => proceed to where
            if (whereStatement && whereStatement.trim() != "")
            {
                if (tile.combineWhere && globalWhereStatement && globalWhereStatement.trim() != "")
                {
                    whereStatement = "(" + globalWhereStatement + ") " + (tile.combineWhereOperator == 1 ? " AND " : " OR ") + "(" + whereStatement + ")";
                    whereParameters = [...globalWhereParameters, ...whereParameters];
                }
                //else do nothing because where statement and parameters are already filled
            }
            else if (tile.combineWhere && globalWhereStatement && globalWhereStatement.trim() != "")
            {
                whereStatement = globalWhereStatement;
                whereParameters = [...globalWhereParameters];
            }

            tiles.push({
                requestId: newRequestId, widgetId: tile.Id, widgetTypeId: tile.WidgetTypeId, dataSourceId: dataSourceId, 
                loaded: false, loading: true, errorText: "", canceled: false,
                whereStatement: whereStatement, whereParameters: whereParameters, parameters: combinedParameters,
                dataSourceTypeId: tile.DataSourceTypeId, properties: tile.properties
            });
        }
    }

    return tiles;
};